/* Footer payment blocks remain the single merchant-editable source. */
(() => {
  if (window.MouniPaymentStrips) return;
  const sync = () => {
    const source = document.querySelector('.mhf__payment-groups');
    if (!source) return;
    const logos = [...source.querySelectorAll('.mhf__payment')];
    if (!logos.length) return;
    document.querySelectorAll('[data-mouni-payment-strip]').forEach(slot => {
      const list = document.createElement('div'); list.className = 'mouni-payment-strip__logos';
      logos.forEach(logo => {
        const copy = logo.cloneNode(true);
        copy.removeAttribute('data-shopify-editor-block'); copy.removeAttribute('style');
        copy.className = 'mouni-payment-strip__logo';
        copy.dataset.group = logo.closest('[data-payment-group]')?.dataset.paymentGroup || 'cards';
        list.append(copy);
      });
      slot.replaceChildren(list); slot.dataset.ready = 'true';
    });
    if (document.querySelector('[data-mouni-payment-strip][data-ready=true]')) document.body.classList.add('mouni-payments-ready');
  };
  window.MouniPaymentStrips = {sync};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',sync,{once:true}); else sync();
  document.addEventListener('shopify:section:load',sync);
  document.addEventListener('mouni:cart-html-refreshed',sync);
})();
